module.exports = __webpack_public_path__ + "static/media/Omni.732de75d.png";